import { EXPERIMENTS_SUCCESSFUL, EXPERIMENTS_REQUESTING, EXPERIMENTS_ERROR } from '../actions/ActionTypes';
const INITIAL_STATE = {
  isFetching: false,
  hasFetched: false,
  hasError: false,
  treatments: {}
};
export default function experiments(state = INITIAL_STATE, action) {
  switch (action.type) {
    case EXPERIMENTS_REQUESTING:
      {
        return Object.assign({}, state, {
          isFetching: true
        });
      }
    case EXPERIMENTS_SUCCESSFUL:
      {
        return Object.assign({}, state, {
          isFetching: false,
          hasFetched: true,
          treatments: action.payload
        });
      }
    case EXPERIMENTS_ERROR:
      return Object.assign({}, state, {
        isFetching: false,
        hasFetched: true,
        hasError: true
      });
    default:
      return state;
  }
}